var _rect, _path, _rect2, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13,
    fill: "#201E26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1193 11.6362H21.7343C20.891 11.6419 20.0904 11.2611 19.5561 10.6003L18.4414 9.0362C17.9159 8.36961 17.1153 7.98709 16.2733 8.00033H13.8803C9.58513 8.00033 8.00001 10.5589 8.00001 14.9095V19.6124C7.99467 20.1295 30.9981 20.1289 30.9996 19.6124V18.245C31.0201 13.8944 29.4758 11.6362 25.1193 11.6362Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.2928,
    width: 23.8635,
    height: 20.3281,
    rx: 6,
    fill: "#FFD23B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22V16.1667C23.2217 16.1667 25.8333 18.7783 25.8333 22H20Z",
    fill: "#545979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22L22.9167 27.0518C24.7205 26.0088 25.832 24.0837 25.8333 22H20Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 27.0518L20 22V16.1667C16.7783 16.1677 14.1675 18.7803 14.1686 22.0019C14.1697 25.2236 16.7822 27.8344 20.0039 27.8333C21.0266 27.833 22.0313 27.5638 22.9171 27.0526L22.9191 27.0502L22.9166 27.0518Z",
    fill: "#343843"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon3);
export default __webpack_public_path__ + "static/media/group_icon3.739b76375fd3012c6225392dc72f367e.svg";
export { ForwardRef as ReactComponent };